import { SAVE_PLANS, PLAN_SELECT } from '../constants/actionTypes';

const INITIAL_STATE = {
  plans: [],
  selectedPlan: null,
};

const savePlans = (state, action) => ({
  ...state,
  plans: action.payload,
});

const applySelectPlan = (state, action) => ({
  ...state,
  selectedPlan: action.payload,
});

const planReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SAVE_PLANS:
      return savePlans(state, action);
    case PLAN_SELECT:
      return applySelectPlan(state, action);
    default:
      return state;
  }
};

export default planReducer;
